import { render, staticRenderFns } from "./CompanyFulfillmentsOmsDetail.vue?vue&type=template&id=dc400780&scoped=true&"
import script from "./CompanyFulfillmentsOmsDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyFulfillmentsOmsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFulfillmentsOmsDetail.vue?vue&type=style&index=0&id=dc400780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc400780",
  null
  
)

export default component.exports